module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_9006.f22157c3.png";